import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type SkipQuiz = {
  studentId: string;
  courseId: string;
  createdAt: string;
  updatedAt: string;
} & ApiError;
export const SkipQuiz = ({
  studentId,
  courseId,
}: {
  studentId: string;
  courseId: string;
}): Promise<SkipQuiz> => {
  return axios.patch(`/course/skippedQuizzes/${courseId}/${studentId}`);
};
